<img [src]="'sdk/close.svg' | assetsPath | async" class="close-icon" alt="" (click)="onClose()" />
<gc-video [play]="true" [id]="videoId" [autoplay]="true"></gc-video>
